import { Button, Input, Link, Modal, toast, useOverlayState } from "@heroui/react";
import { useEffect, useState } from "react";

// 实名认证Modal组件
export const ModalRealname = ({ openGetAppModal }: { openGetAppModal?: (showToast: boolean) => void }) => {
    const state = useOverlayState();
    return (
        <Modal>
            <Modal.Trigger>
                <Button
                    className="bg-warning-400 text-white"
                    size="sm"
                    onPress={state.open}
                >
                    了解更多
                </Button>
            </Modal.Trigger>
            <Modal.Backdrop isOpen={state.isOpen} onOpenChange={state.setOpen}>
                <Modal.Container size="md">
                    <Modal.Dialog>
                        {({ close: _close }) => (
                            <>
                                <Modal.Header className="flex flex-col gap-1">
                                    <Modal.Heading>实名认证</Modal.Heading>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="space-y-4">
                                        <div className="text-gray-600">
                                            <p className="mb-3">
                                                实名认证是保护您和买断/画师权益的重要措施，完成实名后您可以：
                                            </p>
                                            <ul className="list-disc list-inside space-y-2 text-sm">
                                                <li className="text-primary-500">解锁标记机完整功能</li>
                                                <li className="text-primary-500">
                                                    允许您签收开启了实名保护的模板
                                                </li>
                                                <li>提高账户安全性和可信度</li>
                                                <li>享受更多平台功能和权益</li>
                                                <li>维护安全的交易环境</li>
                                            </ul>
                                        </div>
                                        <div className="bg-blue-50 p-4 rounded-lg">
                                            <p className="text-blue-800 text-sm">
                                                <strong>注意：</strong>实名认证需要在手机APP中完成，
                                                {
                                                    openGetAppModal && (
                                                        <Link
                                                            className="text-sm text-blue-800 font-bold underline underline-offset-4 cursor-pointer"
                                                            onPress={() => {
                                                                openGetAppModal(true);
                                                            }}
                                                        >
                                                            您可点此获取APP
                                                        </Link>
                                                    )
                                                }
                                                进入“我的”页面，点击“实名认证”完成实名。
                                            </p>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onPress={state.close}>
                                        关闭
                                    </Button>
                                </Modal.Footer>
                            </>
                        )}
                    </Modal.Dialog>
                </Modal.Container>
            </Modal.Backdrop>
        </Modal>
    );
};

// QQ绑定Modal组件
export const ModalQQBind = ({
    onSave,
}: {
    onSave: (qq: string) => void;
}) => {
    const [qq, setQq] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const state = useOverlayState();

    const handleSave = async () => {
        if (!qq.trim()) {
            toast.warning("请输入QQ号码");
            return;
        }

        if (!/^\d{5,11}$/.test(qq.trim())) {
            toast.warning("请输入有效的QQ号码（5-11位数字）");
            return;
        }

        setIsLoading(true);
        try {
            await onSave(qq.trim());
            setQq("");
            state.close();
        } catch (error) {
            // 错误处理在父组件中
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setQq("");
        state.close();
    };

    return (
        <Modal>
            <Modal.Trigger>
                <Button
                    className="bg-warning-400 text-white"
                    size="sm"
                    onPress={state.open}
                >
                    了解更多
                </Button>
            </Modal.Trigger>
            <Modal.Backdrop isOpen={state.isOpen} onOpenChange={state.setOpen}>
                <Modal.Container size="md">
                    <Modal.Dialog>
                        {() => (
                            <>
                                <Modal.Header className="flex flex-col gap-1">
                                    <Modal.Heading>绑定QQ号码</Modal.Heading>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="space-y-4">
                                        <div className="text-gray-600">
                                            <p className="mb-3">
                                                填写后可使用QQ号来接收模板，无需记住UID，方便快捷。
                                            </p>
                                            <p className="mb-3 text-red-500">
                                                请注意：QQ号码无法在多个帐号重复绑定，如您的QQ已绑定过其他帐号，请先解绑后再进行绑定。
                                            </p>
                                        </div>
                                        <div className="space-y-2 p-1">
                                            <Input
                                                placeholder="请输入您的QQ号码"
                                                value={qq}
                                                onChange={(e) => setQq(e.target.value)}
                                                type="text"
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="tertiary" onPress={handleClose}>
                                        取消
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onPress={handleSave}
                                        isPending={isLoading}
                                        isDisabled={!qq.trim()}
                                    >
                                        {({ isPending }) => (
                                            <>
                                                {isPending && <span className="loading loading-spinner" />}
                                                保存
                                            </>
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </>
                        )}
                    </Modal.Dialog>
                </Modal.Container>
            </Modal.Backdrop>
        </Modal>
    );
};


export function ModalWelcome() {
    const state = useOverlayState();

    useEffect(() => {
        if (!localStorage.getItem("welcomeTermsAgreed")) {
            state.open();
        }
    }, []);

    const handleClose = () => {
        state.close();
        localStorage.setItem("welcomeTermsAgreed", "true");
    };
    return (
        <Modal.Backdrop isOpen={state.isOpen} onOpenChange={state.setOpen} isDismissable={false}>
            <Modal.Container size="lg">
                <Modal.Dialog>
                    {() => (
                        <>
                            <div className="h-36" style={{
                                backgroundImage: "url('/images/banners/template_protection_welcome.png')",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }} />
                            <Modal.Body>
                                <div className="flex flex-col gap-6">
                                    <div className="text-xl font-bold text-center">欢迎使用兽聚汇模板保护服务</div>
                                    <div className="text-sm text-center">兽聚汇模板保护是兽聚汇提供的一项增值服务，旨在保护模板作者的权益，最大程度地避免模板在未经授权的情况下被恶意传播或复制。</div>
                                    <div className="flex flex-col gap-2.5 text-sm mt-2">
                                        <div className="font-bold">目前该服务处于公开测试阶段，我们希望您花费些许时间来阅读以下内容：</div>
                                        <ol>
                                            <li>1. 使用本系统前，您需明白并理解模板保护服务仅作为模板作者的权益保护手段，并不能保证模板100%不被恶意传播或复制。</li>
                                            <li>2. 本系统不涉及模板的使用和传播，并不为模板实际使用负责。</li>
                                            <li>3. 本系统的在运营测试期间不收取任何费用，您可以免费访问该系统。</li>
                                            <li>4. 使用本系统时，请先阅读<span className="text-primary cursor-pointer" onClick={() => window.open("/terms/user-terms", "_blank")}>《兽聚汇用户服务协议》</span>和<span className="text-primary cursor-pointer" onClick={() => window.open("/terms/privacy", "_blank")}>《兽聚汇隐私政策》</span>。</li>
                                            <li>5. 该系统仍在持续迭代中，请您在使用过程中遇到问题时，及时向我们反馈。</li>
                                        </ol>
                                        <div >以上，祝您在使用过程中愉快，欢迎将您的反馈及时反馈给我们。</div>
                                    </div>
                                    <div className="text-center text-sm">官方服务QQ群：908274958</div>
                                    <div className="flex justify-end">
                                        <Button className="bg-primary text-white rounded-full w-full" size="sm" onPress={handleClose}>我知道了</Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </>
                    )}
                </Modal.Dialog>
            </Modal.Container>
        </Modal.Backdrop>
    );
}
